/**
 * Brazilian Portuguese (pt-BR) mappings for HelpSupport
 * Simple key-value pairs for easy maintenance
 */

export const helpSupportPtBR = {
  // Title
  "Help & Support": "Ajuda e Suporte",
  
  // Description
  "Need help? Check out our FAQ section or reach out to our support team directly.": "Precisa de ajuda? Confira nossa seção de perguntas frequentes ou entre em contato diretamente com nossa equipe de suporte.",
  "We're here to assist you with any questions you might have.": "Estamos aqui para ajudá-lo com quaisquer dúvidas que você possa ter.",
  
  // Buttons
  "Email Support": "Suporte por Email",
  "View FAQ": "Ver Perguntas Frequentes",
  
  // Additional Information
  "Our support team typically responds within 14 business days. We prioritize Pro responses.": "Nossa equipe de suporte normalmente responde em até 14 dias úteis. Priorizamos respostas para usuários Pro."
};